<template>
  <div class="filters-holder flex no-wrap items-center q-mb-sm">
    <q-icon name="engp:engp-ico-filter-outline" class="q-mr-xs" />
    <div class="row no-wrap full-width q-col-gutter-sm">
      <div class="col">
        <q-input
          :modelValue="modelValue.nameOrSubtitle"
          @update:modelValue="updateModelValue('nameOrSubtitle', $event)"
          label="Name"
          dense
          outlined
          clearable
        />
      </div>
      <div v-if="mode === 'list'" class="col">
        <q-select
          :modelValue="modelValue.categories"
          @update:modelValue="updateModelValue('categories', $event)"
          @clear="updateModelValue('categories', [])"
          label="Category"
          :options="categories"
          multiple
          clearable
          dense
          outlined
          options-dense
        />
      </div>
      <div class="col">
        <q-select
          :modelValue="modelValue.state"
          @update:modelValue="updateModelValue('state', $event)"
          @clear="updateModelValue('state', undefined)"
          label="State"
          :options="stateOptions"
          emit-value
          clearable
          dense
          outlined
          options-dense
          map-options
          option-value="value"
          option-label="label"
        />
      </div>
      <div class="col">
        <q-select
          :modelValue="modelValue.cloudTypes"
          @update:modelValue="updateModelValue('cloudTypes', $event)"
          @clear="updateModelValue('cloudTypes', [])"
          label="Cloud Type"
          :options="cloudTypesOptions"
          emit-value
          multiple
          clearable
          map-options
          dense
          outlined
          options-dense
          option-value="value"
          option-label="label"
        />
      </div>
      <div class="col">
        <q-select
          :modelValue="modelValue.orderable"
          @update:modelValue="updateModelValue('orderable', $event)"
          label="Show only orderable"
          :options="[
            { label: 'Yes', value: true },
            { label: 'No', value: false },
          ]"
          emit-value
          dense
          outlined
          map-options
          options-dense
        />
      </div>
    </div>
    <q-btn
      icon="engp:engp-ico-restart"
      :ripple="false"
      flat
      class="btn--no-hover"
      size="sm"
      @click="$emit('resetFilters')"
    >
      <q-tooltip>Reset</q-tooltip>
    </q-btn>
  </div>
</template>

<script>
export default {
  name: 'CatalogFilter',
  props: {
    modelValue: {
      type: Object,
    },
    canReset: {
      type: Boolean,
    },
    mode: {
      type: String,
    },
    categories: {
      type: Array,
    },
  },
  data() {
    return {
      stateOptions: [
        { label: 'Default', value: 'default' },
        { label: 'Not recommended', value: 'notRecommended' },
        { label: 'Planned', value: 'planned' },
      ],
      cloudTypesOptions: [
        { label: 'Azure', value: 'azure' },
        { label: 'Alibaba', value: 'alibaba' },
        { label: 'On Premises', value: 'onpremises' },
        { label: 'Swisscom', value: 'swisscom' },
      ],
    };
  },
  methods: {
    updateModelValue(type, value) {
      this.$emit('update', { type, value });
    },
  },
};
</script>

<style lang="scss" scoped>
.filters-holder {
  padding: 15px;
  background-color: #fff;
  border-radius: 15px;
}
</style>
